import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Col, Form } from 'antd';
import Input from 'src/pages/userComponents/text-field/index';
import TextComponent from '@sharedComponent/typography/TextComponent';

import StepButton from '@pages/userComponents/Step-Button/StepButton';

import 'src/pages/userComponents/userStyle.scss';
import 'antd/dist/antd.css';

const AuthorizedSignatoryPresentational = ({ navigateDisabled, sendEmailStart, isAuthorisedLoading }) => {
	const history = useHistory();
	const [email, setEmail] = useState('');
	const [allow, setAllow] = useState(false);
	const [emailerr, setEmailerr] = useState(false);
	const [nextBtnDisable, setNextBtnDisable] = useState(true);
	let regEmail =
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	const onFinish = () => {
		// && hrName && hrMobile && hrEmail

		if (email && allow) {
			navigateDisabled?.(false);
		} else {
			navigateDisabled?.(true);
		}
	};

	const validateMessages = (changeValue, allValue) => {
		if (allValue.email && !regEmail.test(allValue.email)) {
			setAllow(false);
		} else {
			setAllow(true);
		}
	};

	const validateForm = (e) => {
		if (e.target.name == 'email') {
			if (!regEmail.test(email)) {
				setEmailerr('Email is not valid');
				setNextBtnDisable(true);
			} else {
				setNextBtnDisable(false);
				setEmailerr(false);
			}
		}
	};

	const isValidEmail = useMemo(() => regEmail.test(email), [email]);

	console.log('isValidEmail', isValidEmail);
	return (
		<div>
			<Col>
				<div className="headercontainer">
					<TextComponent className="medium" style={{ width: '350px' }}>
						Authorised Signatory Contact
					</TextComponent>

					<TextComponent className="text-lg">The agreement will be shared for your signatory to sign digitally.</TextComponent>
					<TextComponent className="text-lg">You will also receive a copy of this agreement for reference.</TextComponent>
					<Form onFinish={onFinish()} onValuesChange={validateMessages}>
						<Form.Item className="authorize_email_container" name="email">
							<div className="global_input_Container">
								<Input
									name="email"
									type="text"
									onBlur={validateForm}
									labels={
										<span>
											Email of Authorised Signatory <text style={{ color: 'red' }}>*</text>
										</span>
									}
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
								<div>
									<TextComponent className="errorText">{emailerr}</TextComponent>
								</div>
							</div>
						</Form.Item>
					</Form>
				</div>
				<StepButton
					loading={isAuthorisedLoading}
					disabled={!isValidEmail || isAuthorisedLoading}
					handleNext={() => {
						sendEmailStart(email, history);
						// history.push('/user/signature/4');
					}}
					buttonText={'Next'}
				/>
			</Col>
		</div>
	);
};
export default AuthorizedSignatoryPresentational;
